<template>
  <a-modal
    title="发票抬头"
    :width="800"
    :visible="visible"
    :confirmLoading="loading"
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="() => { $emit('cancel') }"
    :afterClose="afterHideEditModal"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="invoiceModalForm"
        :model="InvoiceForm"
        :rules="InvoiceFormRules"
        :label-col="formLayout.labelCol"
        :wrapper-col="formLayout.wrapperCol"
      >
        <a-form-model-item
          label="发票类型"
          :required="true"
          prop="invoiceType"
        >
          <a-radio-group
            v-model="InvoiceForm.invoiceType"
          >
            <a-radio v-for="item in invoiceTypes" :key="item.code" :value="item.code">{{item.name}}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="抬头类型"
          required
          prop="buyerType"
        >
          <a-radio-group
            v-model="InvoiceForm.buyerType"
            button-style="solid"
            @change="handleBuyerTypeChange"
          >
            <a-radio-button v-for="item in buyerTypes"
              :key="item.code"
              :value="item.code"
              :disabled="InvoiceForm.invoiceType === 1 && item.code === 2 "
            >{{ item.name }}</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="名称"
          required
          prop="invoiceParam.buyerName"
        >
          <a-input
            v-model="InvoiceForm.invoiceParam.buyerName"
            placeholder="请输入名称"
          />
        </a-form-model-item>
        <template v-if="InvoiceForm.buyerType===1">
          <a-form-model-item
            label="纳税人识别号"
            required
            prop="invoiceParam.buyerTaxNumber"
          >
            <a-input
              v-model="InvoiceForm.invoiceParam.buyerTaxNumber"
              placeholder="请输入纳税人识别号"
            />
          </a-form-model-item>
        </template>
        <a-form-model-item
          label="电子邮箱"
          required
          prop="invoiceParam.email"
        >
          <a-input
            v-model="InvoiceForm.invoiceParam.email"
            placeholder="请输入电子邮箱"
          />
        </a-form-model-item>
        <a-form-model-item
          label="说明"
          required
        >
          <div style="padding-top: 9px; line-height: 22px;font-size: 12px;">
            <p>1：《增值税专用发票》和《增值税普通发票》均为电子票据，需提供电子邮箱。</p>
            <p>2：发票申请通过后，将在五个工作日内开具并发送邮件，请注意查收！</p>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>


import { deepClone } from '../../../../../utils/utils'

const iForm = {
  buyerType: 1,
  invoiceType: 1,
  invoiceParam: {
    buyerName: '',
    buyerTaxNumber: '',
    email: ''
  }
}
let _this = null;
let validatePass2 =  (rule, value, callback) => {
  if (_this.InvoiceForm.buyerType === 1){
    if (!value){
      callback("请输入纳税人识别号")
    }
    if (value.length > 50){
      callback("纳税人识别号长度在1~50之间")
    }
  }
  return true
};
const buyerTypes = [{code: 1,name: '单位'},{code: 2,name: '个人'}]
const invoiceTypes = [{code: 1,name: '增值税专用发票'},{code: 2,name: '增值税普通发票'}]
const InvoiceFormRules = {
  invoiceParam: {
    buyerName:[
      {required: true, message: '请输入名称'},
      {type:'string', min:1,max:50, message: '名称长度在1~50之间'}
    ],
    email:[
      {required: true, message: '请输入电子邮箱'},
      {type: 'email', message: '请输入正确的邮箱地址',}
    ],
    buyerTaxNumber: [{ required: false, validator: validatePass2, trigger: "change" }]
  },
}
export default {
  name: "ApplyInvoiceModal",
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    const formLayout = {
      labelCol: {
        xs: {span: 20},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 20},
        sm: {span: 17}
      }
    }
    return {
      formLayout,
      buyerTypes,
      InvoiceForm: deepClone(iForm),
      invoiceTypes,
      InvoiceFormRules,
      form: this.$form.createForm(this),
      isDisabled: true,
      invoiceType: "2",
      titleType: "2",
      disabledPerson: false
    }
  },
  created() {
    this.$nextTick(async () => {
      _this = this
    })
  },
  watch: {
    // visible(val) {//普通的watch监听
    //   console.log(val, iForm)
    //   if (val) {
    //     this.InvoiceForm = iForm
    //   }
    // },
  },
  methods: {
    handleSubmit(){
      this.$refs.invoiceModalForm.validate(async valid =>{
        if (valid){
          this.$emit('ok', this.InvoiceForm)
        }
      })
    },
    handleBuyerTypeChange(e){
      let val = e.target.value;
      if (val === 2){
        this.InvoiceForm.invoiceParam.buyerTaxNumber = ''
      }
    },
    afterHideEditModal(){
      this.InvoiceForm = iForm
    },
  }
}
</script>
